import axios from 'axios';

export const search = (providerId, searchCriteria) => (
	new Promise((resolve, reject) => {
		axios.get(`/providers/${providerId}/acrs-search`, { params: searchCriteria })
			.then(({ data }) => {
				resolve(data);
			})
			.catch(err => reject(err));
	})
);
